


















import Vue, { VueConstructor } from 'vue';
import { AxiosError, AxiosResponse } from 'axios';
import { SearchCustomer, CustomerTable } from './components';
import services from '../../services';
import { ErrorStatesOptions, SearchParams, PaginatorProperties, OrderType, SearchCustomerInformation } from '../../models';
import { SearchCustomerVm } from './viewModel';
import mapper from './mappers';
import { ToastMessage } from '@/plugins/toast/models/message';
import lang from '../../common/lang/de';
import { TokenHelper } from '../../common/utils/TokenHelper';
import { MessageSpecialSituation } from '../../common/components';

const { CallCenterService } = services;

export default (Vue as VueConstructor<
  Vue & {
    $refs: {};
  }
>).extend({
  name: 'CallCenterIndex',
  components: {
    SearchCustomer,
    CustomerTable,
    MessageSpecialSituation
  },
  data() {
    return {
      searchCustomerVm: [] as SearchCustomerVm[],
      searchParams: {} as SearchParams,
      hasSearch: false as boolean,
    };
  },
  computed: {
    items() {
      if (this.hasSearch) {
        return this.$store.getters['storeTable/getItems'];
      }
      return [];
    },
  },
  methods: {
    hasNotSearch() {
      this.hasSearch = false;
    },
    inputSearchCustomer(searchParams: SearchParams) {
      if (TokenHelper.isExpired()) {
        sessionStorage.setItem('exp', 'true');
        this.$router.push({ name: 'Index' });
      } else {
        this.searchParams = searchParams;
        this.searchParams.paginator = {
          sortBy: 'AnspName',
          order: OrderType.ASC,
          rowsPerPage: this.$store.getters['storeTable/getRowsPerPage'],
          currentItems: this.$store.getters['storeTable/getPage'],
        } as PaginatorProperties;
        this.searchParams.callcenterDoingSearch = this.$store.getters['user/getCustomerNumber'];

        this.$store.dispatch('storeTable/setLoader', true);
        CallCenterService.getCallCenterCustomer(this.searchParams)
          .then((result: AxiosResponse<SearchCustomerInformation>) => {
            this.hasSearch = true;
            this.searchCustomerVm = (result.data.customers && result.data.customers.length > 0) ? mapper.mapCustomerDtoListToSearchCustomerVmList(result.data.customers) : [];
            this.$store.dispatch('storeTable/setItems', this.searchCustomerVm);
            this.$store.dispatch('storeTable/setPaginationTotalItems', result.data.totalCustomer);
            this.$store.dispatch('storeTable/setLoader', false);
          })
          .catch((err: AxiosError) => {
            if (err.response !== undefined && (err.response.status === 401 || err.response.status === 500)) {
              this.showError(ErrorStatesOptions.NotAuthorized);
              this.$store.dispatch('storeTable/setLoader', false);
              this.$router.push({ name: 'Index' });
            } else {
              this.showError(ErrorStatesOptions.UnexpectedError);
              this.$store.dispatch('storeTable/setLoader', false);
            }
          });
      }
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
});
